import React from "react";
import Text from "../../styleguide/Text";
import CustomButton from "../CustomButton";
import { SvgIconType } from "../../helpers/SvgIcon";

function FormHeader({
  title,
  buttonRoute,
  buttonIcon,
  buttonLabel,
  tooltipTitle,
  buttonOnClick,
}: {
  title: string;
  buttonRoute?: string;
  buttonIcon: SvgIconType;
  buttonLabel: string;
  tooltipTitle?: string;
  buttonOnClick?: () => void;
}) {
  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
      <Text
        variant="h3"
        component="h3"
        className="mb-4 font-semibold text-slate-900"
        gutterBottom>
        {title}
      </Text>
      {buttonIcon && (
        <CustomButton
          icon={buttonIcon}
          variant="contained"
          className="mr-1 mt-1"
          tooltipTitle={tooltipTitle}
          navigate={buttonRoute}
          onClick={buttonOnClick}>
          {buttonLabel}
        </CustomButton>
      )}
    </div>
  );
}

export default FormHeader;
